// Constantes d'interface pures (pas de données métier ici : tout vient désormais de l'API,
// voir src/api/measurementApi.js). Ne conserver dans ce fichier que ce qui ne dépend d'aucun
// backend.

export const TOUCHES_PAVE = ['7', '8', '9', '⌫', '4', '5', '6', 'C', '1', '2', '3', ',', '0', '00', '↓', 'OK'];
